import { Divider, Flex, Row } from "antd";
import { ClaimKanbanLane } from "./components/ClaimKanbanLane";
import { ClaimKanbanFilters } from "./components/ClaimKanbanFilters";
import type { LaneGroup } from "./ClaimKanbanOverview";
import { groupColors } from "./ClaimKanbanOverview";
import { herstelKanbanMockData } from "./data/herstelKanbanMockData";

interface Lane {
  key: string;
  label: string;
  group: LaneGroup;
}

const lanes: Lane[] = [
  {
    key: "calculatie_geaccordeerd",
    label: "Calculatie geaccordeerd",
    group: "intake",
  },
  {
    key: "voertuig_bij_hersteller",
    label: "Voertuig bij hersteller",
    group: "calculatie",
  },
  {
    key: "voertuig_hersteld",
    label: "Voertuig hersteld",
    group: "calculatie",
  },
  {
    key: "terug_bij_bestuurder",
    label: "Terug bij bestuurder",
    group: "afgerond",
  },
];

export default function ClaimKanbanHerstelOverview() {
  return (
    <div style={{ padding: 16 }}>
      <Flex vertical gap={16}>
        <ClaimKanbanFilters />
        <Divider style={{ margin: 0 }} />

        <Row className="overflow-x-scroll flex-nowrap" gutter={[16, 16]}>
          {lanes.map((lane) => (
            <ClaimKanbanLane
              key={lane.key}
              title={lane.label}
              claims={herstelKanbanMockData[lane.key] ?? []}
              groupColor={groupColors[lane.group]}
            />
          ))}
        </Row>
      </Flex>
    </div>
  );
}
